/** Преобразование позиций документа к строкам таблицы */
export const mapDocItemsToDraw = (docItems) =>
  docItems.map((i) => ({
    ...i,
    item: i.item?.name,
    item2: i.item2?.name,
    itemcode: i.item?.code,
    measure: i.measure?.name,
    measure2: i.measure2?.name,
    pricelist: i.pricelist?.name,
    price: i.price,
    amount: i.amount,
    difference: (Number(i.amount) || 0) - (Number(i.realamount) || 0),
    total: i.total,
    salepercent: i.salepercent,
    frontprice: i.frontprice,
    itemcomment: i.itemcomment,
  }));

/** Преобразование документов к строкам таблицы */
export const mapDocumentsToDraw = (documents, moment) =>
  documents.map((d) => ({
    ...d,
    isConducted: d.ok === 1,
    number: d.docid,
    creationTime: moment(d.time).format("DD.MM.YYYY HH:mm:ss"),
    stock: d.store?.name,
    stock2: d.store2?.name,
    comment: d.comment,
  }));
